import(/* webpackMode: "eager" */ "/codebuild/output/src716261501/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/not-found.tsx");
